// Should render:
// `"2024-07-22T08:00:00"` as `"Thursday, July 22 at 8:00 AM"`
// `"2024-07-22T15:30:00"` as `"Thursday, July 22 at 3:30 PM"`
export const formatAppointmentDateTime = (datetime: string): string => {
  const dateObj = new Date(datetime);
  const options: Intl.DateTimeFormatOptions = {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
  };
  return dateObj.toLocaleDateString(undefined, options);
};